import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getTutorsTable } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';

export default function TutorsTable({ ids }) {
  const { course_enrollment_id, subject_enrollment_id } = ids || {};
  const { loading, data } = useSelector((state) => state.refund.refundTutorsTable);
  const dispatch = useDispatch();
  useEffect(() => {
    course_enrollment_id && dispatch(getTutorsTable({ course_enrollment_id, subject_enrollment_id }));
  }, [course_enrollment_id, subject_enrollment_id]);

  const tutorData = [
    {
      slNo: 1,
      tutorName: 'Nahala',
      sessions: '10th',
      phoneNumber: '9874675876',
    },
    {
      slNo: 2,
      tutorName: 'Sona',
      sessions: '20th',
      phoneNumber: '9874675876',
    },
    {
      slNo: 3,
      tutorName: 'Stephy',
      sessions: '',
      phoneNumber: '9874675876',
    },
  ];
  const ROWS = [
    { label: 'SL.No', value: 'slNo' },
    { label: 'Tutor Name', value: 'tutorName' },
    { label: 'Sessions', value: 'sessions' },
    { label: 'Phone Number', value: 'phoneNumber' },
  ];
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 530 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {ROWS.map(({ label }, i) => (
              <TableCell key={i}>{label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableCell colSpan={4} align="center">
              <CircularProgress />
            </TableCell>
          ) : data.length == 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <NoDataFound />
              </TableCell>
            </TableRow>
          ) : (
            data.map(({ full_name, mobile_number, subject_name, total_sessions }, i) => (
              <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {i + 1}
                </TableCell>
                <TableCell>{full_name || '-'}</TableCell>
                <TableCell>{total_sessions || '-'}</TableCell>
                <TableCell>{mobile_number || '-'}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
